import React from "react"
import { motion } from "framer-motion"
import BlockPoster from "../Components/BlockPoster/BlockPoster"
import CardGrid from "../Components/Card/CardGrid"
import Footer from "../Components/Footer/Footer"
import PageTitle from "../Components/PageTitle/PageTitle"
import Slider from "../Components/Slider/Slider"
import CardItems from "../Components/Card/CardItems.json"

import "./pages.css"

function Home() {
  return (
    <motion.section
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.3 }}
    >
      <CardGrid items={CardItems.slice(0, 9)} />
      <PageTitle
        title="Things to do in "
        span="Ethiopia"
        subtitle="Not to be missed"
      />
      <Slider />
      <CardGrid items={CardItems.slice(9)} two={true} />
      <BlockPoster
        title="Salt caravans of the Danakil depression"
        subtitle="The thick warm air, the hazy sky and the rugged empty mountains"
      />
      <PageTitle
        title="the Land of "
        span="Origins"
        subtitle="come and visit"
        reverse
      />
      <Footer />
    </motion.section>
  )
}

export default Home
